import { Box, styled, Typography, TypographyProps } from "@mui/material";

export const DatasetBlockRoot = styled(Box)(() => ({
	display: "flex",
	flexDirection: "column",
	flexShrink: 0,
}));
export const DatasetText = styled(Typography)<TypographyProps>(() => ({ fontSize: "10px", textAlign: "center" }));
export const DatasetTextBold = styled(Typography)<TypographyProps>(() => ({ fontWeight: "600", fontSize: "10px" }));
